export default __webpack_public_path__ + "static/media/icon-facebook.8deee3e3.svg";